// language=GraphQL
export const ALL_MANDATORY_SETTINGS_QUERY = `query Query($withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {
  mandatorySettings: allTravelPricingMandatorySettings {
    id
    isMandatory
    useRules
    rules @include(if: $withRules) {
      id
      checkAccommodationTypes
      accommodations @include(if: $withRulesAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withRulesAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      familyPackages @include(if: $withRulesFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withRulesFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withRulesFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      checkAccommodationAddons
      accommodationAddons @include(if: $withRulesAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      checkAgeGroups
      ageGroups @include(if: $withRulesAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      useAgeFilter
      ageFilter @include(if: $withRulesAgeFilter) {
        id
        minAge
        maxAge
      }
      checkDateRange
      startDate
      endDate
      checkTravelDate
      travelDates @include(if: $withRulesTravelDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withRulesTravelDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withRulesTravelDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withRulesTravelDatesExtensions) {
          id
          label
          info
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_MANDATORY_SETTINGS_QUERY = `query Query($id: ID!, $withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {
  mandatorySettings: travelPricingMandatorySettings(id: $id) {
    id
    isMandatory
    useRules
    rules @include(if: $withRules) {
      id
      checkAccommodationTypes
      accommodations @include(if: $withRulesAccommodations) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withRulesAccommodationsAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      familyPackages @include(if: $withRulesFamilyPackages) {
        id
        ratioServiceNo
        accommodation @include(if: $withRulesFamilyPackagesAccommodation) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        name
        label
        info
        capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          partialOccupancyAllowed
        }
        addons @include(if: $withRulesFamilyPackagesAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
      }
      checkAccommodationAddons
      accommodationAddons @include(if: $withRulesAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
        }
      }
      checkAgeGroups
      ageGroups @include(if: $withRulesAgeGroups) {
        id
        name
        type
        icon
        minAge
        maxAge
      }
      useAgeFilter
      ageFilter @include(if: $withRulesAgeFilter) {
        id
        minAge
        maxAge
      }
      checkDateRange
      startDate
      endDate
      checkTravelDate
      travelDates @include(if: $withRulesTravelDates) {
        id
        dateNo
        startDate
        endDate
        availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        includesExtension
        extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {
          id
          dateNo
          startDate
          endDate
          includesExtension
          json
        }
        extension @include(if: $withRulesTravelDatesExtension) {
          id
          label
          info
        }
        packageSettings @include(if: $withRulesTravelDatesPackageSettings) {
          id
          ratioPackageNo
          price
          availabilityStatus
        }
        json
        extensions @include(if: $withRulesTravelDatesExtensions) {
          id
          label
          info
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_MANDATORY_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelPricingMandatorySettingsInput, $withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {
    mandatorySettings: createTravelPricingMandatorySettings(input: $input) {
      id
      isMandatory
      useRules
      rules @include(if: $withRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withRulesAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        familyPackages @include(if: $withRulesFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withRulesFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withRulesFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        checkAgeGroups
        ageGroups @include(if: $withRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withRulesTravelDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withRulesTravelDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withRulesTravelDatesExtensions) {
            id
            label
            info
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_MANDATORY_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingMandatorySettingsInput, $withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {
    mandatorySettings: updateTravelPricingMandatorySettings(input: $input) {
      id
      isMandatory
      useRules
      rules @include(if: $withRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
          capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withRulesAccommodationsAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        familyPackages @include(if: $withRulesFamilyPackages) {
          id
          ratioServiceNo
          accommodation @include(if: $withRulesFamilyPackagesAccommodation) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          name
          label
          info
          capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {
            id
            totalCapacity
            rangesAllowed
            partialOccupancyAllowed
          }
          addons @include(if: $withRulesFamilyPackagesAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
          }
        }
        checkAgeGroups
        ageGroups @include(if: $withRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          includesExtension
          extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {
            id
            dateNo
            startDate
            endDate
            includesExtension
            json
          }
          extension @include(if: $withRulesTravelDatesExtension) {
            id
            label
            info
          }
          packageSettings @include(if: $withRulesTravelDatesPackageSettings) {
            id
            ratioPackageNo
            price
            availabilityStatus
          }
          json
          extensions @include(if: $withRulesTravelDatesExtensions) {
            id
            label
            info
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_MANDATORY_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingMandatorySettingsInput) {
    deleteTravelPricingMandatorySettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_MANDATORY_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingMandatorySettingsInput) {
    forceDeleteTravelPricingMandatorySettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const MANDATORY_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioPersonalAddons: Boolean = false, $withRatioBookingAddons: Boolean = false, $withRatioCollectiveAddons: Boolean = false, $withRatioPersonalDiscounts: Boolean = false, $withRatioAccommodationAddons: Boolean = false) {
  groupedDependents: travelPricingMandatorySettingsDependents(id: $id) {
    ratioPersonalAddons @include(if: $withRatioPersonalAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioBookingAddons @include(if: $withRatioBookingAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioCollectiveAddons @include(if: $withRatioCollectiveAddons) {
      id
      label
      info
    }
    ratioPersonalDiscounts @include(if: $withRatioPersonalDiscounts) {
      id
      ratioServiceNo
      name
      label
      info
    }
    ratioAccommodationAddons @include(if: $withRatioAccommodationAddons) {
      id
      ratioServiceNo
      name
      label
      info
    }
  }
}`
